import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCEZbEBFY8CXZLuM5oWSo2P7q88jLA65fU",
  authDomain: "transfer-6fcd3.firebaseapp.com",
  projectId: "transfer-6fcd3",
  storageBucket: "transfer-6fcd3.firebasestorage.app",
  messagingSenderId: "941158566810",
  appId: "1:941158566810:web:c295a62c88253914f20823",
  measurementId: "G-5FYRRJGTX1",
};

const VAPID_KEY = "BK89LrDT9D44xyzIcw-lvQS_gJJhnlpZJ5qzk2tX4z6RnxcGk1CfwYmnLsOPw9oBtnhz6uKFBANQoLUh2msLUg0";

// Initialize Firebase app (singleton)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

let messagingInstance = null;

function getMessagingInstance() {
  if (!messagingInstance) {
    try {
      messagingInstance = getMessaging(app);
    } catch (e) {
      console.warn('Firebase Messaging not supported:', e);
    }
  }
  return messagingInstance;
}

/**
 * Request notification permission and get FCM token.
 * Returns the token string or null if denied/unavailable.
 */
export async function requestNotificationPermission() {
  try {
    // Check browser support
    if (!('Notification' in window)) {
      console.warn('Notifications not supported in this browser');
      return null;
    }
    if (!('serviceWorker' in navigator)) {
      console.warn('Service Workers not supported');
      return null;
    }

    // Request permission
    const permission = await Notification.requestPermission();
    console.log('Notification permission:', permission);
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    // Register Firebase messaging service worker explicitly
    let swRegistration;
    try {
      swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/',
      });
      console.log('Firebase SW registered, scope:', swRegistration.scope);
      
      // Wait for the service worker to be ready/activated
      if (swRegistration.installing) {
        await new Promise((resolve) => {
          swRegistration.installing.addEventListener('statechange', (e) => {
            if (e.target.state === 'activated') resolve();
          });
          // Timeout fallback
          setTimeout(resolve, 3000);
        });
      } else if (swRegistration.waiting) {
        await new Promise((resolve) => {
          swRegistration.waiting.addEventListener('statechange', (e) => {
            if (e.target.state === 'activated') resolve();
          });
          setTimeout(resolve, 3000);
        });
      }
    } catch (swError) {
      console.error('Firebase SW registration failed:', swError);
      return null;
    }

    const messaging = getMessagingInstance();
    if (!messaging) {
      console.error('Firebase Messaging instance not available');
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: swRegistration,
    });

    if (token) {
      console.log('FCM Token obtained:', token.substring(0, 20) + '...');
    } else {
      console.warn('No FCM token returned');
    }
    return token;
  } catch (error) {
    console.error('Error getting notification permission/token:', error);
    return null;
  }
}

/**
 * Listen for foreground messages.
 * Returns an unsubscribe function.
 */
export function onForegroundMessage(callback) {
  const messaging = getMessagingInstance();
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
}
